module.exports = __webpack_public_path__ + "site-build/img/icon-2.77528924.svg";